/**
 * Human-readable label for a filter key/value (for pills).
 * @param {string} key - filter key
 * @param {*} value - filter value
 * @param {Object} options - { occupation, education, maritalStatus, religions }
 */
export function getFilterLabel(key, value, options = {}) {
  if (key === "gender") return value;
  if (key === "premium") return value === "yes" ? "Premium" : "Non-Premium";
  if (key === "is_web") return value === "web" ? "Web" : "Mobile";
  const { occupation = [], education = [], maritalStatus = [], religions = [] } = options;
  if (key === "occupation" && occupation.length) {
    const item = occupation.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "education" && education.length) {
    const item = education.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "marital" && maritalStatus.length) {
    const item = maritalStatus.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "religion" && religions.length) {
    const item = religions.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "created_date_start" || key === "created_date_end") {
    return value
      ? new Date(value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : value;
  }
  return value;
}
